export const CATEGORY_ORDER = ["Roti", "Bagel", "Tortilla", "Frozen Dough", "Supplier"];
export const CHANNELS = ["Shopee", "Tokopedia/TikTok", "WhatsApp", "Offline"];
export const SALES_TYPES = ["Sales", "Sample Gratis", "Endorsement"];
export const WASTE_REASONS = ["Kadaluarsa/Basi", "Gosong/Overbake", "Gagal Produksi", "Jatuh/Rusak", "Berjamur", "Retur Customer", "Lainnya"];

export const todayJkt = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());

export const shiftDate = (d, n) => {
  const x = new Date(`${d}T00:00:00Z`);
  x.setUTCDate(x.getUTCDate() + n);
  return x.toISOString().slice(0, 10);
};

export const fmtDate = (d) =>
  d ? new Date(`${d}T00:00:00Z`).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" }) : "-";

export const fmtDateLong = (d) =>
  d ? new Date(`${d}T00:00:00Z`).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }) : "-";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-";

export const signed = (n) => (n > 0 ? `+${n}` : `${n}`);

export const isPackUnit = (p) => p?.stock_unit === "lembar" && (p?.sales_pack_size || 1) > 1;

export const packInfo = (qty, p) => {
  if (!isPackUnit(p)) return null;
  const a = Math.abs(qty);
  return `≈ ${qty < 0 ? "-" : ""}${Math.floor(a / p.sales_pack_size)} pack jual + ${a % p.sales_pack_size} lembar sisa`;
};

export const saleUnitLabel = (p) => (p?.is_bundle ? "paket" : isPackUnit(p) ? `pack (×${p.sales_pack_size})` : p?.stock_unit || "pcs");
export const purchaseUnitLabel = (p) => ((p?.purchase_pack_size || 1) > 1 ? `pack (×${p.purchase_pack_size} ${p.stock_unit})` : p?.stock_unit || "pcs");

export const groupBy = (arr, fn) =>
  arr.reduce((acc, x) => {
    const k = fn(x);
    (acc[k] = acc[k] || []).push(x);
    return acc;
  }, {});
